// Libs
import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Components
import Layout from '../../components/Layout';
import Kits from './Kits/Kits';
import SharedKits from './SharedKits/SharedKits';
import SharedKitDetails from './SharedKitDetails/SharedKitDetails';
import KitDetails from './KitDetails/KitDetails';
import KitMaterials from '../../components/Kits/KitMaterials/KitMaterials';
import SharedKitMaterials from '../../components/Kits/SharedKitMaterials/SharedKitMaterials';

// Styles
import { useStyles } from './KitsStyles';

const MyKits = () => {
  const { classes } = useStyles();

  return (
    <Routes>
      <Route
        path={'/'}
        exact
        element={
          <Layout className={{ layout: classes.layout }}>
            <Kits />
          </Layout>
        }
      />
      <Route
        path={'/shared'}
        exact
        element={
          <Layout className={{ layout: classes.layout }}>
            <SharedKits />
          </Layout>
        }
      />
      <Route
        path={'/shared/:kitId'}
        exact
        element={
          <Layout className={{ layout: classes.layout }}>
            <SharedKitDetails />
          </Layout>
        }
      />
      <Route
        path={'/shared/:kitId/materials'}
        exact
        element={<SharedKitMaterials />}
      />
      <Route
        path={'/:kitId'}
        exact
        element={
          <Layout className={{ layout: classes.layout }}>
            <KitDetails />
          </Layout>
        }
      />
      <Route path={'/:kitId/materials'} exact element={<KitMaterials />} />
    </Routes>
  );
};

export default MyKits;
